import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
/**
 * Service to create / download Reports
 */
@Injectable({
  providedIn: 'root'
})
export class BasedatareportService {
  /**
   * constructor
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService,) {

  }

  /**
   * Get all Reports
   * @returns 
   */
  getReports() {
    return this.http.get(`${this.environment.getApiUrl()}/report`);
  }
  /**
   * Download a Report by its Name
   * @param report 
   * @returns 
   */
  downloadReport(report) {
    return this.http.get(`${this.environment.getApiUrl()}/report/${report}`, { responseType: 'blob' });
  }
  /**
   * Start the Reportprocess
   * @returns 
   */
  startReport() {
    return this.http.post(`${this.environment.getApiUrl()}/report/MASTER_DATA_ZIP_REPORT`, {});

  }
}
